import { useEffect, useState } from "react";
import type { CanvasRecoveryState, SaveState } from "./session-controller.js";
import { canvasCopy } from "../copy/zh-CN.js";

export function CanvasRecoveryNotice({ recovery, saveStatus, listingError, onExport, onRetry }: {
  recovery: CanvasRecoveryState;
  saveStatus?: SaveState["status"];
  listingError?: string | undefined;
  onExport(): void;
  onRetry(): void;
}) {
  const [unconfirmedTooLong, setUnconfirmedTooLong] = useState(false);
  const unconfirmed = !recovery.durable;
  useEffect(() => {
    setUnconfirmedTooLong(false);
    if (!unconfirmed) return;
    // Presentation grace only: never change durability or leave-page guards.
    // Depend on the boolean, not the recovery object: continuous edits must
    // not restart this timer while neither storage destination acknowledges.
    const timer = setTimeout(() => setUnconfirmedTooLong(true), 1500);
    return () => clearTimeout(timer);
  }, [unconfirmed]);
  const failed = saveStatus === "save_failed" || saveStatus === "conflict";
  const showWarning = recovery.localError || (unconfirmed && (unconfirmedTooLong || failed));
  return (
    <>
    {listingError ? <aside className="studio-conflict" role="alert">{listingError}</aside> : null}
    {showWarning ? <aside className="studio-conflict" role="alert">
      <span>{!recovery.durable ? canvasCopy.unsavedWarning : canvasCopy.localStorageWarning}</span>
      <button type="button" onClick={onExport}>{canvasCopy.exportLocal}</button>
      {recovery.localError ? <button type="button" onClick={onRetry}>{canvasCopy.retrySave}</button> : null}
    </aside> : null}
    </>
  );
}
